import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/icon/index';

export default function CmsFaqInfo({ text, title }) {
    return (
        <div className="cms-faq-info">
            <h1 className="cms-faq-info--title">{title}</h1>
            <div className="cms-faq-info--body">
                <div className="cms-faq-info--icon">
                    <Icon symbol="faq" size="x-large" />
                </div>
                <div className="cms-faq-info--text" dangerouslySetInnerHTML={{ __html: text }} />
            </div>
        </div>
    );
}

CmsFaqInfo.propTypes = {
    text: PropTypes.string,
    title: PropTypes.string,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/faq-info/index.js